import * as React from "react";
import * as cn from "classnames";

const styles = require("./DialogFrames.less");

export const DialogFrame: React.SFC<{className?: string}> = ({children, className}) => {
    return <div className={cn(styles.frame, className)}>
        {children}
    </div>;
};

export const FullScreenDialogFrame: React.SFC<{className?: string}> = ({children, className}) => {
    return <DialogFrame className={cn(styles.fullscreen, className)}>
        {children}
    </DialogFrame>;
};

export const HugeDialogFrame: React.SFC<{className?: string}> = ({children, className}) => {
    return <DialogFrame className={cn(styles.huge, className)}>
        {children}
    </DialogFrame>;
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DialogLayout/Custom/DialogFrames.tsx